(function ($) {

  "use strict";
  Drupal.behaviors.civicChartsToggle = {
    attach: function (context, settings) {
      $(once('civicChartsToggle', 'body', context)).each(function () {
        $('.chart--toggle').on('click', function(e){
            e.preventDefault();
            if (!$(this).hasClass('active')) {
                $(this).parent().find('.chart--toggle').removeClass('active');
                $(this).addClass('active');
                $(this).parent().next('.chart-wrapper').find('.chart-container').removeClass('active');

                var cId = $(this).data('container');
                $('#' + cId).addClass('active');
            }
        });
      });
    }
  };

})(jQuery);
